const template = `
<div class="bottom-conditions">
	<form>
		<div class="conditions-container base-horse">
			<div class="conditions-inner">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-base-horse-reduction-row">
						<label>%Min%
							<div class="styled-select">
								<select class="number-of-races min-winners" name="baseHorse[minWinners]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races max-winners" name="baseHorse[maxWinners]"></select>
								<span class="sprite dropdown"></span>
							</div> %includes-winner%
						</label>
						<br><br>
						<label class="mr-20">
							%comment% <input type="text" style="width:420px" class="comment" name="baseHorse[comment]">
						</label>

					</div><!-- ROW -->

				</div>
			</div>
		</div><!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
